<script setup>

import { inject } from 'vue';
import Valeur from './Valeur.vue';

const valeurSelectionnee = inject('valeurSelectionnee');
const calculablesSelectionnes = inject('calculablesSelectionnes');

</script>

<template>
	<div v-if="valeurSelectionnee != null">
		<label class="titre">Valeur sélectionnée</label>
		<div class="panel-valeur">
			<label class="intitule">Expression :</label>
			<label class="abrege texte-expression" v-tooltip.left="calculablesSelectionnes[0].expression.texte">
				{{ calculablesSelectionnes[0].expression.texte }}
			</label>
			<template v-for="(valeur, variable) in valeurSelectionnee.contexte">
				<label class="intitule">{{ variable }} :</label>
				<label class="abrege" v-tooltip.left="valeur">
					{{ valeur }}
				</label>
			</template>
			<label class="intitule">Valeur :</label>
			<Valeur :valeur="valeurSelectionnee"/>
			<template v-if="valeurSelectionnee?.valPrec != null">
				<label class="intitule">Valeur préc. :</label>
				<Valeur :valeur="valeurSelectionnee.valPrec"/>
			</template>
		</div>
	</div>
</template>

<style scoped>

.panel-valeur {
	padding: 5px;
	border: 1px solid var(--couleur-bordure);
	border-radius: 4px;
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	align-items: center;
	gap: 2px;
	white-space: nowrap;
}

.abrege {
	text-overflow: ellipsis;
	overflow: hidden;
	flex-grow: 1;
}

.intitule {
	flex-grow: 0;
}

.texte-expression {
	font-size: 10px;
}

</style>